/**
 * @generated SignedSource<<7edcfc4477d7b64013ddc2468d249af5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CardBrand = "AMERICAN_EXPRESS" | "CHINA_UNIONPAY" | "DISCOVER" | "DISCOVER_DINERS" | "EBT" | "EFTPOS" | "FELICA" | "INTERAC" | "JCB" | "MASTERCARD" | "OTHER_BRAND" | "SQUARE_CAPITAL_CARD" | "SQUARE_GIFT_CARD" | "UNKNOWN" | "VISA";
import { FragmentRefs } from "relay-runtime";
export type ExistingSquareCardsList_customer$data = {
  readonly id: string;
  readonly squareCards: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly cardBrand: CardBrand;
        readonly enabled: boolean;
        readonly expMonth: number;
        readonly expYear: number;
        readonly id: string;
        readonly lastFour: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ExistingSquareCardsList_customer";
};
export type ExistingSquareCardsList_customer$key = {
  readonly " $data"?: ExistingSquareCardsList_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExistingSquareCardsList_customer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExistingSquareCardsList_customer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "enabled",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "includeUserCards",
          "value": true
        }
      ],
      "concreteType": "SquareCardOnFileConnection",
      "kind": "LinkedField",
      "name": "squareCards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareCardOnFileEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareCardOnFile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cardBrand",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expMonth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expYear",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastFour",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "squareCards(enabled:true,includeUserCards:true)"
    }
  ],
  "type": "Customer",
  "abstractKey": null
};
})();

(node as any).hash = "3ee35a9ca0a7f8ff2fa8e0b34b1098fb";

export default node;
